import React from 'react'
import classNames from 'classnames'
import { CurrencyInput, Icon, Input, Text } from 'components'
import { paymentMethods } from '../data'
import styles from '../ProposalWizard.module.scss'

const PaymentMethodSection = ({ form, touched, errors, onChange, onBlur }) => {
  const showDownPayment =
    form.paymentMethod === 'financiamento' ||
    form.paymentMethod === 'parcelamento'
  const showInstallments = form.paymentMethod === 'parcelamento'

  return (
    <section className={styles.section}>
      <p className={styles.sectionTitle}>
        <span className={styles.sectionNumber}>3</span>
        Forma de pagamento*
      </p>
      <Text fontSize="small" color="lightBlueColor">
        Selecione a forma de pagamento da proposta.
      </Text>
      <div className={styles.paymentCards}>
        {paymentMethods.map(method => (
          <button
            key={method.value}
            type="button"
            className={classNames(styles.paymentCard, {
              [styles.selected]: form.paymentMethod === method.value,
            })}
            onClick={() => onChange('paymentMethod', method.value)}
          >
            <Icon
              type={method.icon}
              color="primaryColor"
              size={20}
              className={styles.stepIcon}
            />
            <span className={styles.paymentCardTitle}>{method.label}</span>
            <Text fontSize="small" color="lightBlueColor">
              {method.description}
            </Text>
          </button>
        ))}
      </div>
      {touched.paymentMethod &&
        !errors.isPaymentValid &&
        !form.paymentMethod && (
          <span className={styles.span}>Selecione a forma de pagamento.</span>
        )}
      {showDownPayment && (
        <CurrencyInput
          id="downPaymentValue"
          label="Valor da entrada*"
          description="A entrada refere-se unicamente à entrada do imóvel. Os honorários deverão ser pagos à vista."
          className={styles.currencyInput}
          value={form.downPaymentValue}
          onChange={(id, value) => onChange(id, value)}
          autoComplete="off"
          disableAbbreviations
          onBlur={onBlur('downPaymentValue')}
          hasError={touched.downPaymentValue && !errors.isDownPaymentValid}
          errorMessage="Campo obrigatório"
        />
      )}
      {showInstallments && (
        <Input
          id="installmentsCount"
          type="number"
          min={1}
          max={420}
          maxLength={3}
          label="Número de parcelas (em meses)*"
          placeholder="Ex.: 24"
          value={form.installmentsCount}
          onChange={e => onChange('installmentsCount', e.target.value)}
          onBlur={onBlur('installmentsCount')}
          hasError={touched.installmentsCount && !errors.isInstallmentsValid}
          errorMessage="Informe um valor entre 1 e 420."
        />
      )}
    </section>
  )
}

export default React.memo(PaymentMethodSection)
